import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-[#FDF8F0] pt-8 pb-10 md:pt-20 md:pb-24 px-5 overflow-hidden" data-id="element-19">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-4 md:gap-10 items-center" data-id="element-20">
        <div className="space-y-3 md:space-y-6 relative z-10 flex flex-col" data-id="element-21">
          <div className="inline-block self-start bg-[#F0F4EC] text-[#4A6741] px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm font-medium tracking-wide border border-[#4A6741]/20" data-id="element-22">
            Protocolo SOS
          </div>

          <h1 className="text-[1.65rem] leading-[1.2] md:text-5xl lg:text-6xl font-bold text-[#2D1F0E] md:leading-tight" data-id="element-23">
            Qué hacer cuando tu hijo colapsa en público sin gritar, castigar ni
            congelarte
          </h1>

          <h2 className="text-base leading-relaxed md:text-xl text-[#4A6741] font-medium" data-id="element-24">
            Una guía práctica en español para madres latinas en USA que
            necesitan saber exactamente qué hacer en una crisis sensorial, justo
            en el momento real.
          </h2>

          <div className="w-full" data-id="element-25">
            <a href="#offer-cta" className="
                inline-flex items-center justify-center gap-2
                bg-[#C75C3A] hover:bg-[#b04f30] text-white
                font-medium text-base md:text-lg px-8 py-3.5 md:py-4 rounded-full
                transition-all duration-300 ease-in-out
                shadow-[0_4px_14px_0_rgba(199,92,58,0.39)]
                hover:shadow-[0_6px_20px_rgba(199,92,58,0.23)]
                hover:-translate-y-0.5
                w-full md:w-auto min-h-[48px]
                no-underline
              " data-id="element-26">
              Quiero saber qué hacer
              <ArrowRight className="w-5 h-5" data-id="element-27" />
            </a>
            <p className="text-xs md:text-sm text-[#6B5D4F] mt-2 md:mt-3 text-center md:text-left font-medium" data-id="element-28">
              Acceso inmediato • Pago único • Úsalo desde hoy
            </p>
          </div>
        </div>

        <div className="relative order-last md:order-none -mt-1 md:mt-0" data-id="element-29">
          <div className="absolute inset-0 bg-gradient-to-tr from-[#D4A853]/20 to-transparent rounded-2xl md:rounded-3xl transform translate-x-3 translate-y-3 -z-10" data-id="element-30"></div>
          <div className="absolute inset-0 bg-[#4A6741]/10 rounded-2xl md:rounded-3xl transform -translate-x-2 -translate-y-2 -z-10" data-id="element-31"></div>
          <img src="https://cdn.magicpatterns.com/uploads/2R9ouE6w2jeRzArKUS1ndV/Cover_1.png" alt="Protocolo SOS: Crisis Sensoriales - Madre sosteniendo las manos de su hijo" className="rounded-2xl md:rounded-3xl shadow-xl w-full object-contain md:h-[500px] border-4 border-white bg-white" data-id="element-32" />
        </div>

        <div className="md:col-span-2 mt-2 md:mt-8 space-y-5" data-id="element-33">
          <div className="flex flex-col md:flex-row gap-3 md:gap-8 justify-center items-start md:items-center bg-white/60 backdrop-blur-sm p-4 md:p-6 rounded-2xl border border-[#D4A853]/20" data-id="element-34">
            {['Baja el caos más rápido sin improvisar', 'Aprende qué hacer en los primeros 60 segundos', 'Protege el vínculo sin dejar pasar todo'].map((bullet, idx) => <div key={idx} className="flex items-start gap-2.5" data-id="element-35">
                <div className="bg-[#F0F4EC] p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-36">
                  <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#4A6741]" data-id="element-37" />
                </div>
                <span className="text-[#2D1F0E] font-medium text-sm md:text-base" data-id="element-38">
                  {bullet}
                </span>
              </div>)}
          </div>

          <div className="bg-[#F0F4EC]/60 rounded-2xl py-5 px-6 md:py-6 md:px-8 max-w-2xl mx-auto text-center border border-[#4A6741]/10" data-id="element-39">
            <p className="text-lg md:text-xl text-[#2D1F0E] font-semibold leading-relaxed" data-id="element-40">
              No necesitas seguir improvisando.
            </p>
            <p className="text-base md:text-lg text-[#4A6741] leading-relaxed mt-2 font-medium" data-id="element-41">
              En la próxima crisis, tendrás pasos claros, herramientas concretas
              y una forma más calmada de responder.
            </p>
          </div>
        </div>
      </div>
    </section>;
}